import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '@screen';
import styled from 'styled-components';

/**
 * Styled text component for generic ad text in pause ad modal.
 * Displays ad-related text with shadow effect at the bottom-right of the screen.
 */
const PauseAdText = styled.span<React.CSSProperties>`
  position: fixed;
  text-shadow: 4px 4px 4px black;
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${Screen.widthRatio * 24}px;
  left: ${Screen.widthRatio * 1740}px;
  top: ${Screen.widthRatio * 1021}px;
}
`;

export default PauseAdText;
